
/*START:LOAD-556*/
import config from '../config';
import moment from 'moment';
/*STOP:LOAD-556*/
import services from "../services/HttpService";
import { mapActions } from "vuex";
import store from '../store/';
import axios from "axios";
import Router from '../router'; 

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const _getPermissionsMapping = (data) => {
  let permMap = {};
  const perm = data.permissionSets;
  if (perm.length) {
      for (let i = 0; i < perm.length; i++) {
          const permissions = perm[i].Role.ModulePermissions;
          if (permissions.length) {
              for (let j = 0; j < permissions.length; j++) {
                  const _pObj = permissions[j],
                      moduleName = _pObj.Module.slug,
                      permType = _pObj.p_name;
                  if (permMap[moduleName] !== 'all') {
                      permMap[moduleName] = permType;
                  }
              }
          }
      }
  }
  return permMap;
};

const kebab = (str) => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'long_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name'
};


const formatResult = (place, address, self) => {
  let returnData = {};
  for (let i = 0; i < place.address_components.length; i++) {
      let addressType = place.address_components[i].types[0];
      
      if(addressType == 'administrative_area_level_1'){
          self.form[address + 'short_name'] = place.address_components[i].short_name;
      }
      if (ADDRESS_COMPONENTS[addressType]) {
          let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
      }
  }
  returnData['latitude'] = place.geometry.location.lat();

  self.form[address + 'address'] = '';
  self.form[address + 'address'] = place.formatted_address;
  self['hidden_' + address + 'address'] = place.formatted_address ? place.formatted_address : '';
  self['hidden_' + address + 'city'] = returnData.locality ? returnData.locality : '';
  self['hidden_' + address + 'state'] = returnData.administrative_area_level_1 ? returnData.administrative_area_level_1 : '';
  self.form[address + 'city'] = returnData.locality ? returnData.locality : '';
  self.form[address + 'state'] = returnData.administrative_area_level_1 ? returnData.administrative_area_level_1 : '';
  self.form[address + 'country'] = returnData.country ? returnData.country : '';
  self.form[address + 'pincode'] = returnData.postal_code ? returnData.postal_code : '';
  self.form[address + 'lat'] = place.geometry.location.lat() ? place.geometry.location.lat() : '';
  self.form[address + 'lng'] = place.geometry.location.lng() ? place.geometry.location.lng() : '';
}

const displayCityStateAny = (city, state, state_short) => {
  let text = '';
  if(city != ''){
    text += getTitleCase(city); 
    if(state_short != ''){
      text += ', '+state_short.toUpperCase(); 
    }
  } else if(state != ''){
      text += getTitleCase(state); 
  } else {
    text += getTitleCase(config.anywhereStr); 
  }
  return text;
} 




const getUserAgent = () => {
  if( navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)
  ){
      return true;
    }
  else {
      return false;
    }
}

let radiuslist = [{name:'10',id:10},{name:'50',id:50},{name:'100',id:100},{name:'200',id:200}, {name:'ANY',id:'ANY'}];

const dateDiff = (date1, date2, mode) => {
  date1 = new Date(date1);
  date2 = date2 ? new Date(date2) : new Date();
  const seconds = Math.floor((date1 - date2) / 1000);
  let interval = Math.floor(seconds / 31536000);  
  if (mode === 's') {
    return Math.floor(seconds);
  }
  if (interval > 1) {
    return interval + ' years';
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + ' months';
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + ' days';
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + ' hours';
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + ' minutes';
  }
  return Math.floor(seconds) + ' secondADDRESS_COMPONENTSs';
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
  }
  else {
    cancelFullScreen.call(doc);
  }
};

/*START:LOAD-556*/
const getLoadSizes = ()  => {
  let returnObject = [
    {'name':config.ANYStr,'id':config.ANYStr},
    {'name':config.LTLStr,'id':config.LTLStr},
    {'name':config.FULLStr,'id':config.FULLStr}
  ]
  return returnObject;
};
/*STOP:LOAD-556*/

const getDateDiffDisplay = (date) => {
  let currDate = new Date();
  let diff = Math.floor(dateDiff(currDate, date, 's') / 60),
  h = Math.floor(diff / 60),
  m = diff % 60;
  if (m < 0) {
    m = 0;
  }
  if (h < 0) {
    h = 0;
  }
  if (h <= 0) {
    return m + 'm';
  } else if (h > 8) {
    return '8h+';
  } else {
    return h + 'h' + ' ' + m + 'm';
  }
};
const getEquipmentListDisplay = (equipmentCodes,equipmentCodeList,equipmentList,displayForm,cb)=>{
  let equipmentCodesArray = equipmentCodes.split(',').map(String);
  if((equipmentCodesArray && equipmentCodesArray.length > 0) && (equipmentCodeList && equipmentCodeList.length > 0) && (equipmentList && equipmentList.length > 0) && (equipmentCodeList.length == equipmentList.length)){
    let tmpEquipmentList = [];
    equipmentCodesArray.map(async function(code){
      let codeIndex = equipmentCodeList.indexOf(code);
      if(codeIndex >= 0){
        await tmpEquipmentList.push(equipmentList[codeIndex]["name"]);
      }
    });
    if(tmpEquipmentList.length > 0){
      let equipmentNameList = tmpEquipmentList.join(', ');
      if(displayForm == config.shortFormStr){
        cb((equipmentNameList.length < config.equipmentListLength) ? equipmentNameList : equipmentNameList.substr(0,config.equipmentListLength)+config.tripleDots);
      }else{
        cb(equipmentNameList);
      }
    }else{
      cb(config.ANYStr);
    }
  }else{
    cb(config.ANYStr);
  }
};
const getDescriptionDisplay = (description) => {
  let tmpDescription = getDataDisplay(description);
  if(tmpDescription != config.notProvidedStr){
      if(tmpDescription.length < config.descriptionLength){
        return tmpDescription;
      }else{
        return (tmpDescription.substr(0, config.descriptionLength)+config.tripleDots);
      }
  }else{
      return tmpDescription;
  }
};
const getPhoneFormatDisplay = (phone) => {
  let returnStr = [];
  if(phone.includes(',')){
    let phoneArr = phone.split(',');    
    phoneArr.map((phn)=> {
      let tmpPhObj = {};
      if(phn.length == 11){
        tmpPhObj['key'] = phn.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4');
        tmpPhObj['val'] = phn.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4');
        returnStr.push(tmpPhObj);
      }else{
        tmpPhObj['key'] = phn;
        tmpPhObj['val'] = phn.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '1($1) $2-$3');
        returnStr.push(tmpPhObj);
      }
    })
    return returnStr;
  } else {
    if(phone && phone.length > 0){
        let tmpPhObj = {};
        if(phone.length == 11){
            tmpPhObj['key'] = phone;
            tmpPhObj['val'] = phone.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4');
            returnStr.push(tmpPhObj);
            return returnStr;
        }else{
            tmpPhObj['key'] = phone;
            tmpPhObj['val'] = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '1($1) $2-$3');
            returnStr.push(tmpPhObj);
            return returnStr;
        }
    }else{
      tmpPhObj['key'] = config.notProvidedStr;
      tmpPhObj['val'] = config.notProvidedStr;
      returnStr.push(tmpPhObj);
      return returnStr;
    }
  }
};
const getDataDisplay = (fieldName) => {
  if(fieldName && fieldName.length > 0){
      return fieldName;
  }else{
      return config.notProvidedStr;
  }
};
const getNotesNameFromKey = (fieldName, aggregatorsKeyVal, aggrName) => {
  let notesFinalVal = '';
  if(fieldName && fieldName.indexOf(',') > -1){
      let notesArr = fieldName.split(",");
      let notesTmpArr = [];
      notesArr.map(function(data){
          notesTmpArr.push(aggregatorsKeyVal[aggrName][data]);
      });
      notesFinalVal = notesTmpArr.join(',');
  } else {
      notesFinalVal = fieldName;
  }
  return ((notesFinalVal && notesFinalVal.length > 0)?notesFinalVal:config.notProvidedStr);
};
const getDistanceDisplay = (distance) =>{
  if(distance == 'Not provided'){
    return distance;
  }
  return (parseFloat(distance).toFixed(2));
}
const getTitleCase = (str) =>{
  return str.replace(/\w\S*/g,function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

const mirrorUser = (switch_user_uuid, back_user_uuid, self, cb) => {
  const wApp = window.getApp;
  wApp.$emit("showLoader", {
      show: true
  });
  services
      .post(
          "users/switch-account", {
              switch_user_uuid: switch_user_uuid,
              back_user_uuid: back_user_uuid
          }, {
              Authorization: "Bearer:" + self.$store.state.user.token
          }
      )
      .then(res => {
          wApp.$emit("showLoader", {
              show: false
          });
          const userData = Object.assign({}, res.data);
          delete userData.permissionSets;
          userData.permissions = _getPermissionsMapping(res.data);
          cb(userData);
      })
      .catch(err => {
        cb(err);
      });
}

const updateLoginTimeStamp = (store) => {
  if(store.state.user){
    store.dispatch('updateLoginTimeStamp', {loginTimeStamp: moment(new Date()).unix()})
    .then(function(res){

    });
  }
}

const refreshTokenGenerate = (store) => {
  console.log('utils refresh token')
  let sessionTime = moment(new Date()).unix() - store.state.loginTimeStamp;
  let curPath = Router.app._route.path.toString();
  console.log('sessionTime',sessionTime,moment(new Date()).unix(), store.state.loginTimeStamp)
    if(sessionTime <= config.sessionTimeForRefreshToken){
        axios.get(config.apiUrl + "users/refresh-token?uuid="+store.state.user.uuid, { 'Content-type': 'application/x-www-form-urlencoded' })
        .then(res => {
            if(res.status === 200){
                const userData = Object.assign({}, res.data);
                delete userData.permissionSets;
                let loginTimeStamp = moment(new Date()).unix();
                userData.permissions = _getPermissionsMapping(res.data);
                
                
                store.dispatch('login', {user: userData})
                .then(function(res2){
                    
                });
                window.location.href = curPath;
            }
        })
        .catch(err => {
            
        })
    } else {
      store.dispatch('logout');
      let loginUrl = '/login';
      if(store.state.loginType && store.state.loginType != ''){
          loginUrl += '/'+store.state.loginType;
      }
      Router.push(loginUrl);
    }
}

const updateLoggedInUserInfo = (store,userData) => {
  store.dispatch('updateLoggedInName', {name: userData.UserContacts.first_name+' '+userData.UserContacts.last_name});
  if(userData.UserContacts.image_path != ""){
    store.dispatch('updateUserProfilePic', {userProfilePic: userData.UserContacts.image_path});
  }else{
    store.dispatch('updateUserProfilePic', {userProfilePic: config.defaultProfilePicPath});
  }
  
  store.dispatch('updateLoggedInEmail', {email: userData.email});
  store.dispatch('updateLoggedInAltPhone', {altPhoneNumber: userData.UserContacts.phone_2});
  store.dispatch('updateLoggedInContactPhone', {contactPhoneNumber: userData.UserContacts.phone_1});
  store.dispatch('updateLoggedInAddress', {address: userData.UserContacts.address});
}

const shortenLongStrings = (s,n) => {
  String.prototype.trunc = String.prototype.trunc ||
  function(n){
      return (this.length > n) ? this.substr(0, n-1) + '...' : this;
  };
  return s.trunc(n);
}

const generatePin = (store,userData) => {
  store.dispatch('updateLoggedInTmpPin', {pin: userData.pin_no});
  if(userData.pin_no.length==0){
    let pinGenerateForm = {
      "pin_no":"NULL"
    };
    services.post("users/generate-pin", pinGenerateForm, {Authorization: "Bearer " + store.state.user.token})
    .then(res => {
        if (res.data.status) {
          store.dispatch('updateLoggedInPin', {pin: pinGenerateForm["pin_no"]});
        }
    })
    .catch(err => {
    });
  }
}

const tableReArrangementSetMinHeight = (allMinHeightArr) => {
  var mainTr11 = document.getElementsByClassName("custom_table_tr");
  for(var i = 0; i < mainTr11.length; i++){
    let singleTrValue11 = mainTr11[i].getElementsByTagName('tr');
    for(var j = 0; j < singleTrValue11.length; j++){
      let singleTdValue11 = singleTrValue11[j].getElementsByTagName('td');
      for(var k = 0; k < singleTdValue11.length; k++){
        singleTdValue11[k].height = allMinHeightArr[i]
      }
    }
  }
}

const tableReArrangement = () => {
  let mainTr = document.getElementsByClassName("custom_table_tr");
  let allMaxHeightArr = [];
  for(let i = 0; i < mainTr.length; i++){
    let singleTrValue = mainTr[i].getElementsByTagName('tr');
    let singleTdArr = [];
    for(let j = 0; j < singleTrValue.length; j++){
      let singleTdValue = singleTrValue[j].getElementsByTagName('td');
      for(let k = 0; k < singleTdValue.length; k++){
        singleTdArr.push(singleTdValue[k].offsetHeight)
      }
    }
    allMaxHeightArr.push(Math.max(...singleTdArr))
  }
  var mainTr1 = document.getElementsByClassName("custom_table_tr");
  for(var i = 0; i < mainTr1.length; i++){
    let singleTrValue1 = mainTr1[i].getElementsByTagName('tr');
    for(var j = 0; j < singleTrValue1.length; j++){
      let singleTdValue1 = singleTrValue1[j].getElementsByTagName('td');
      for(var k = 0; k < singleTdValue1.length; k++){
        singleTdValue1[k].height = allMaxHeightArr[i]
      }
    }
  }
}

const calculateMinTrHeightOnLoad = () => {

  let allMinHeightArr = [];
  var mainTr = document.getElementsByClassName("custom_table_tr");
  for(let i = 0; i < mainTr.length; i++){
    let singleTrValue = mainTr[i].getElementsByTagName('tr');
    let singleTdArr = [];
    for(let j = 0; j < singleTrValue.length; j++){
      let singleTdValue = singleTrValue[j].getElementsByTagName('td');
      for(let k = 0; k < singleTdValue.length; k++){
        singleTdArr.push(singleTdValue[k].offsetHeight)
      }
    }
    allMinHeightArr.push(Math.max(...singleTdArr))
  }
  return allMinHeightArr.filter(Number);
}

const restrictedWords = () => {
  // console.log('restrictedWords');
}

const updateMaxTalkClicked = () => {
  const wApp = window.getApp;
  wApp.$emit("showLoader", {
    show: true
  });
  services.get(
    "users/is-maxtalk-clicked", {
      Authorization: "Bearer:" + store.state.user.token
    }
  )
  .then(res => {
    wApp.$emit("showLoader", {
      show: false
    });
    if (res.data.status) {
      store.dispatch('updateLoggedInMaxTalkClicked', {maxTalkClicked: 1});
    }
  })
  .catch(err => {
  });
}

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  dateDiff,
  getUserAgent,
  getLoadSizes,
  radiuslist,
  formatResult,
  displayCityStateAny,
  getDateDiffDisplay,
  getEquipmentListDisplay,
  getDescriptionDisplay,
  getPhoneFormatDisplay,
  getDataDisplay,
  getDistanceDisplay,
  getNotesNameFromKey,
  getTitleCase,
  _getPermissionsMapping,
  mirrorUser,
  updateLoginTimeStamp,
  refreshTokenGenerate,
  updateLoggedInUserInfo,
  shortenLongStrings,
  generatePin,
  tableReArrangement,
  calculateMinTrHeightOnLoad,
  tableReArrangementSetMinHeight,
  restrictedWords,
  updateMaxTalkClicked
};


// WEBPACK FOOTER //
// ./src/util/index.js